export const linesToList = (s) => s.split("\n").map((x) => x.trim()).filter(Boolean);
export const commaToList = (s) => s.split(",").map((x) => x.trim()).filter(Boolean);

export const AdminTitle = ({ title, children, actions }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div><h1 className="text-3xl sm:text-4xl">{title}</h1>{children && <p className="mt-2 text-ink-soft max-w-2xl">{children}</p>}</div>
    {actions}
  </div>
);

export const AField = ({ id, label, hint, children }) => (
  <div>
    <label htmlFor={id} className="field-label">{label}</label>
    {children}
    {hint && <p className="mt-1 text-xs text-ink-muted">{hint}</p>}
  </div>
);

export const AInput = ({ id, label, hint, value, onChange, ...rest }) => (
  <AField id={id} label={label} hint={hint}>
    <input id={id} className="field" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={`${id}-input`} {...rest} />
  </AField>
);

export const ATextarea = ({ id, label, hint, value, onChange, rows = 4 }) => (
  <AField id={id} label={label} hint={hint}>
    <textarea id={id} rows={rows} className="field" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={`${id}-input`} />
  </AField>
);

export const ASelect = ({ id, label, value, onChange, options }) => (
  <AField id={id} label={label}>
    <select id={id} className="field" value={value} onChange={(e) => onChange(e.target.value)} data-testid={`${id}-select`}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </AField>
);

export const StatusPill = ({ status }) => {
  const map = {
    published: "bg-teal-light text-teal", draft: "bg-cream-deep text-ink-soft", new: "bg-clay-light text-clay-dark",
    in_progress: "bg-[#FFF4E5] text-[#8A5300]", closed: "bg-sage-light text-sage-dark", verified: "bg-sage-light text-sage-dark", needs_review: "bg-[#FFF4E5] text-[#8A5300]",
  };
  return <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${map[status] || "bg-cream-deep"}`}>{status.replace("_", " ")}</span>;
};

export const Table = ({ head, children, testId }) => (
  <div className="card-soft !bg-white overflow-x-auto" data-testid={testId}>
    <table className="w-full text-sm">
      <thead className="text-left text-ink-muted border-b border-cream-deep"><tr>{head.map((h) => <th key={h} className="px-4 py-3 font-semibold whitespace-nowrap">{h}</th>)}</tr></thead>
      <tbody className="divide-y divide-cream-deep">{children}</tbody>
    </table>
  </div>
);
